import React from 'react'
import styled from 'styled-components';
import Loader from './Loader';

const Button = ({
    children,
    padding,
    margin,
    width,
    backgroundColor,
    color,
    hoverColor,
    boxShadow,
    loading,
    ...props

}) => {
    return (
        <ButtonBox
            {...props}
            padding={padding}
            margin={margin}
            width={width}
            backgroundColor={backgroundColor}
            color={color}
            hoverColor={color}
            boxShadow={boxShadow}
            disabled={loading?loading:props.disabled}>
            {!loading ? children : <Loader />}
        </ButtonBox>
    )
}

export default Button;

const ButtonBox = styled.button`
    cursor: pointer;
    background: var(--color-morado-claro);
    padding: ${props => props.padding ? props.padding : '16px 32px'};
    color: ${props => props.color ? props.color : 'var(--color-blanco)'};
    border-radius: 10px;
    border: none;
    font-weight: bold;
    transition: all .3s;
    margin: ${props => props.margin ? props.margin : '16px 32px'};
    width: ${props => props.width ? props.width : '100%'};
    display:flex;
    align-items:center;
    justify-content: center;
    box-shadow: ${props => props.boxShadow ? props.boxShadow : 'none'};

    &:hover:not(:disabled){
        background: var(--color-morado-oscuro);
        
    }

    &:active:not(:disabled) {
        position: relative;
        top: 2px
    }

    svg{
        padding-right:8px;
        padding-left:8px;
    }

    :disabled{
        opacity:0.5;
        cursor: not-allowed;
    }
`;

export const SecondaryButton = styled(Button)`
    padding: ${props => props.padding ? props.padding : '16px 32px'};
    background: transparent;
    color: var(--color-morado-oscuro);
    box-shadow: inset 0 0 0 3px var(--color-morado-oscuro);
    transition: all .3s;

    &:hover:not(:disabled) {
        background: var(--color-morado-oscuro);
        color: var(--color-blanco);
    }
`;

export const TertiaryButton = styled(Button)`
    padding: ${props => props.padding ? props.padding : '16px 32px'};
    background: transparent;
    color: ${props => props.color ? props.color : 'var(--color-morado-oscuro)'};
    border: none;
    transition: all .3s;
    text-decoration: underline;
    border-radius:5px;

    &:hover:not(:disabled) {
        background-color: transparent;
        color: ${props => props.hoverColor? props.hoverColor : 'var(--color-rosa)'};
    }
`;

export const CustomButton = styled(Button)`
    padding: ${props => props.padding ? props.padding : '16px 32px'};
    background: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-rosa)'};
    color: ${props => props.color ? props.color : 'var(--color-blanco)'};
    border: none;
    transition: all .3s;

    &:hover:not(:disabled) {
        background-color: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-rosa)'};
        opacity: 0.8;
        color: var(--color-blanco);
    }
`;

export const DangerButton = styled(Button)`
    padding: ${props => props.padding ? props.padding : '16px 32px'};
    background: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-error)'};
    color: ${props => props.color ? props.color : 'var(--color-blanco)'};
    border: none;
    transition: all .3s;

    &:hover:not(:disabled) {
        background-color: ${props => props.backgroundColor ? props.backgroundColor : 'var(--color-error)'};
        opacity: 0.8;
        color: var(--color-blanco);
    }
`;




